import React from 'react';

import { styled, useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import useMediaQuery from '@mui/material/useMediaQuery';
import { getTranslate } from 'react-localize-redux';

import BannerAppScreen from '../../assets/images/BannerAppScreen.png';
import FlipdishAppQR from '../../assets/images/FlipdishAppQR.svg';
import { useAppSelector } from '../../custom-hooks/useAppSelector';
import MobileAppBanner from './MobileAppBanner';
import { useShouldShowFlipdishAppBanner } from './useShouldShowFlipdishAppBanner';

const BannerContainer = styled('div')(({ theme }) => ({
  width: '100%',
  backgroundColor: '#095fb0',
  display: 'flex',
  justifyContent: 'space-between',
  height: theme.spacing(10),
}));

const StyledQRCode = styled('img')(({ theme }) => ({
  width: 'auto',
  height: theme.spacing(9),
}));

const InnerContent = styled('div')({
  display: 'flex',
  flexDirection: 'row',
});

const AppImage = styled('img')(({ theme }) => ({
  marginLeft: theme.spacing(3),
  marginTop: theme.spacing(1.5),
}));

const InnerText = styled('div')(({ theme }) => ({
  display: 'flex',
  height: '100%',
  marginLeft: theme.spacing(3),
  flexDirection: 'column',
  justifyContent: 'center',
}));

const InnerTextTypography = styled(Typography)(({ theme }) => ({
  color: theme.palette.common.white,
}));

const BannerTitle = styled(InnerTextTypography)(({ theme }) => ({
  '&&': {
    fontSize: '1.3rem',
    fontWeight: theme.typography.h4.fontWeight,
    lineHeight: theme.typography.h4.lineHeight,
    letterSpacing: theme.typography.h4.letterSpacing,
    [theme.breakpoints.down('md')]: {
      fontSize: '1rem',
    },
  },
}));

const BannerSubtitle = styled(InnerTextTypography)(({ theme }) => ({
  '&&': {
    fontSize: '0.9rem',
    fontWeight: theme.typography.body1.fontWeight,
    lineHeight: theme.typography.body1.lineHeight,
    letterSpacing: theme.typography.body1.letterSpacing,
    [theme.breakpoints.down('md')]: {
      fontSize: '0.8rem',
    },
  },
}));

const QRContainer = styled('div')(({ theme }) => ({
  height: theme.spacing(8),
  margin: theme.spacing(1),
  marginRight: theme.spacing(3),
  width: theme.spacing(8),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

const FlipdishAppBanner = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const translate = useAppSelector((state) => getTranslate(state.locale));
  const showBanner = useShouldShowFlipdishAppBanner();

  if (!showBanner) {
    return null;
  }

  if (isMobile) {
    return <MobileAppBanner />;
  }

  return (
    <BannerContainer>
      <InnerContent>
        <AppImage src={BannerAppScreen} />
        <InnerText>
          <BannerTitle>
            <strong>{translate('Download_and_log_in')}</strong>
          </BannerTitle>
          <BannerSubtitle>{translate('Flipdish_app_banner_subtitle')}</BannerSubtitle>
        </InnerText>
      </InnerContent>
      <QRContainer>
        <StyledQRCode src={FlipdishAppQR} alt={translate('Scan_to_download_the_app') as string} />
      </QRContainer>
    </BannerContainer>
  );
};

export default FlipdishAppBanner;
